const WorkflowActionTypes = {
  Schedule: 5,
};

export default WorkflowActionTypes;
